<template>
  <div :class="$style.app">
    <Area
      v-bind="$attrs"
    />
    <PlayerStatus />
  </div>
</template>

<script>
import PlayerStatus from '../components/PlayerStatus.vue'
import Area from './components/Area'

export default {
  components: {
    Area,
    PlayerStatus,
  },
}
</script>

<style module lang="scss">
.app {
  :global {
    @import '~@/style/global';
    @include root-styles;
  }
}
</style>
